import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import { Component } from '@angular/core';
import { BusinessAddress, BusinessBaseDocx } from '@models/businesses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BaseDocxService } from '@services/base-docx/base-docx.service';
import { BusinessAddressesState } from '@state/business/address';
import { BusinessBaseDocxsState } from '@state/business/word/business-base-docxs/business-base-docxs.state';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import {
	DropdownOption,
	DropdownResult,
} from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { BusinessBaseDocxDrawerComponent } from './business-base-docx-drawer/business-base-docx-drawer.component';
import { UploadService } from '@services/file/upload.service';
import { downloadFile, getFileNameFromPath } from '@core/util/file';
import { take } from 'rxjs/operators';

enum BaseDocxKebabOptionTypes {
	EDIT = 'edit',
	DELETE = 'delete',
}

@Component({
	selector: 'app-business-base-docx-table',
	templateUrl: './business-base-docx-table.component.html',
	styleUrls: ['./business-base-docx-table.component.scss'],
	animations: [
		trigger('detailExpand', [
			state('collapsed,void', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition(
				'expanded <=> collapsed',
				animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
			),
		]),
	],
	standalone: false,
})
export class BusinessBaseDocxTableComponent {
	public displayedColumns: string[] = [
		'title',
		'type',
		'lastEditedBy',
		'lastEditedOn',
		'actions',
	];
	public columnsToDisplayWithExpand: string[] = [...this.displayedColumns];
	public kebabOptions: DropdownOption<BaseDocxKebabOptionTypes>[] = [
		{ name: 'Edit', value: BaseDocxKebabOptionTypes.EDIT },
		// { name: 'Delete', value: BaseDocxKebabOptionTypes.DELETE },
	];

	public kebabOptionsForDefaultBaseDocx: DropdownOption<BaseDocxKebabOptionTypes>[] =
		[{ name: 'Edit', value: BaseDocxKebabOptionTypes.EDIT }];

	public expandedElement: BusinessBaseDocx | null;
	@Select(BusinessBaseDocxsState.getBusinessBaseDocxs)
	businessBaseDocxs$: Observable<BusinessBaseDocx[]>;

	@SelectSnapshot(BusinessAddressesState.getAll) offices: BusinessAddress[];

	constructor(
		private drawerService: DrawerService,
		private baseDocxService: BaseDocxService,
		private uploadService: UploadService,
	) {}

	onKebabOptionSelected(
		event: DropdownResult<DropdownOption<BaseDocxKebabOptionTypes>>,
		baseDocx: BusinessBaseDocx,
	) {
		if (event.result.value === BaseDocxKebabOptionTypes.EDIT) {
			this.drawerService.openDrawer(BusinessBaseDocxDrawerComponent, {
				title: 'Edit Letterhead & Footer',
				data: { baseDocx },
				size: 'sm',
			});
		}
	}

	async uploadNew(
		event: any,
		lawfirm: BusinessAddress,
		baseDocx: BusinessBaseDocx,
	) {
		const file = event.target.files[0];

		if (!file) {
			return;
		}
		await this.baseDocxService.addOfficeOverride(
			file,
			lawfirm.id,
			cloneDeep(baseDocx),
		);
	}

	async delete(office: BusinessAddress, baseDocx: BusinessBaseDocx) {
		await this.baseDocxService.deleteOfficeOverride(
			office.id,
			cloneDeep(baseDocx),
		);
	}

	async download(path: string) {
		await this.uploadService
			.get$(path)
			.pipe(take(1))
			.subscribe((res) => {
				downloadFile(getFileNameFromPath(path), res);
			});
	}

	trackById(index: number, item: BusinessBaseDocx) {
		return item.id;
	}
}
